export const thailandBangkokSouthProgram = {
  programKey: 'tajlandia-bangkok-i-tropikalne-poludnie',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Tajlandia - Bangkok i tropikalne południe',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Tajlandia:',
  stickySubtitle: 'Bangkok i tropikalne południe',

  pageUrl:
    'https://coolturystki.pl/wycieczki/tajlandia-bangkok-i-tropikalne-poludnie',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/tajlandia-tropikalne-poludnie-railay-beach-mu2bx3j3.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/tajlandia-tropikalne-poludnie-railay-beach-mu2bx3j3.webp',
    imagePosition: 'center bottom',
    summary: '',
    destinations: ['Tajlandia'],
    continent: 'Azja',
    categories: [],
    travelStyles: ['Egzotyka', 'Wypoczynek'],
    catalogPublishedAt: '2026-09-16',
  },

  /* Termin o ID 20: 20 - 31 marca 2027. */
  tripIds: [20],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '20': {
      pilotId: 'krzysiekAurelia',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Bezpośredni lot grupowy z Warszawy',
          description:
            'Wspólna podróż rozpoczyna się na Lotnisku Chopina w Warszawie i prowadzi na lotnisko Bangkok-Suvarnabhumi. Możesz rozpocząć podróż również w Krakowie, Wrocławiu lub Berlinie i dołączyć do połączenia grupowego.',
        },
        hotel: {
          title: 'Hotele 4★ w Bangkoku i Krabi',
          description:
            'Noclegi w pokojach 2-osobowych ze śniadaniami, w dwóch miejscach odpowiadających miejskiej i nadmorskiej części programu.',
        },
      },
    },
  },
}
